import { PayloadAction } from "@reduxjs/toolkit";
import { SessionState } from "../session.slice.ts";

export const setTokenReducer = (
  state: SessionState,
  action: PayloadAction<string | undefined>,
) => {
  state.token = action.payload;
};
